var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_76_66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5991 47.1981C40.6324 47.1981 51.1981 36.6324 51.1981 23.5991C51.1981 10.5657 40.6324 0 27.5991 0C14.5657 0 4 10.5657 4 23.5991C4 36.6324 14.5657 47.1981 27.5991 47.1981Z",
    fill: "#FF4C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1981 23.599C51.1981 36.6267 40.6267 47.1981 27.599 47.1981C25.2271 47.1981 22.9274 46.8489 20.7601 46.1867C30.4526 43.2609 37.5203 34.2547 37.5203 23.599C37.5203 12.9433 30.4526 3.93716 20.7601 1.01136C22.9274 0.349139 25.2271 -3.05176e-05 27.599 -3.05176e-05C40.6267 -3.05176e-05 51.1981 10.5593 51.1981 23.599Z",
    fill: "#FF651E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7035 25.4051C33.4627 25.4051 33.258 25.4051 33.0533 25.4051C28.466 25.3931 23.8786 25.381 19.2792 25.3931C18.8337 25.3931 18.6531 25.3088 18.6049 24.8031C18.3762 21.9856 18.1113 19.1802 17.8584 16.3748C17.7501 15.1467 17.6297 13.9186 17.4972 12.6905C17.437 12.0764 17.437 12.0644 18.0511 12.0644C24.9863 12.0644 31.9215 12.0524 38.8447 12.0524C39.4708 12.0524 39.4588 12.0524 39.3986 12.6905C39.2902 13.7862 39.1698 14.8939 39.1096 15.9896C39.0855 16.4471 38.929 16.5434 38.5076 16.5434C33.3423 16.5314 28.177 16.5314 22.9996 16.5193C22.795 16.5193 22.5903 16.5193 22.3254 16.5193C22.4578 18.0003 22.5903 19.4331 22.7227 20.902C28.0205 20.902 33.2941 20.902 38.64 20.902C38.5798 21.6726 38.5437 22.383 38.4835 23.0934C38.339 24.7549 38.1825 26.4165 38.026 28.066C37.8695 29.7035 37.725 31.353 37.5684 32.9905C37.5323 33.3517 37.4842 33.725 37.4721 34.0862C37.4721 34.3751 37.3036 34.4715 37.0748 34.5317C34.3055 35.3022 31.5242 36.0728 28.7549 36.8314C28.5502 36.8916 28.3094 36.8675 28.1047 36.8073C25.3595 36.0487 22.6144 35.2782 19.8692 34.5196C19.5561 34.4353 19.4357 34.2668 19.4116 33.9537C19.2431 31.9069 19.0625 29.86 18.8698 27.8252C18.8457 27.5362 18.9421 27.452 19.2069 27.452C20.4591 27.452 21.7113 27.464 22.9635 27.452C23.3247 27.452 23.3368 27.6807 23.3609 27.9215C23.4451 28.8005 23.5294 29.6794 23.5776 30.5584C23.5896 30.8714 23.71 31.0038 23.999 31.0761C25.4077 31.4373 26.8164 31.8226 28.2251 32.1838C28.3696 32.2199 28.5382 32.2199 28.6827 32.1838C30.0794 31.8226 31.464 31.4493 32.8607 31.0761C33.1135 31.0038 33.2941 30.9075 33.3182 30.6065C33.4507 28.945 33.5951 27.2834 33.7396 25.6218C33.7637 25.5977 33.7276 25.5375 33.7035 25.4051Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_76_66",
    x: 0,
    y: -0.0000305176,
    width: 55.1981,
    height: 55.1981,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_76_66"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_76_66",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.3212a6695e913ed7dfd25cee344b980e.svg";
export { ForwardRef as ReactComponent };